import React from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Wizard, WizardProps } from '@/_shared/components/Wizard';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { getDelegatesCall } from '@/organization';
import { Aspect } from '../Aspect';
import { Company } from '../Company';
import { Delegate } from '../Delegate';
import { ConfigurationCompletedThankYouPage } from '../TYP';

export const WizardConfiguration = () => {
  const t = useTranslations('configuration');
  const { hrDelegates } = getDelegatesCall.hook();
  const { isDesktop } = useBreakingPoints();

  // On desktop the add-delegate step renders its own Next button right below the
  // form, so the automatic footer Next is hidden to avoid duplicates. Mobile and
  // tablet keep the automatic footer Next as-is.
  const showAddDelegateFooterNext = !isDesktop;

  const wizardSteps: WizardProps['stepsConfig'] = [
    {
      label: t('macroStepTitles.addDelegate'),
      steps: [
        {
          label: 'Delegati',
          // eslint-disable-next-line react/no-unstable-nested-components
          component: ({ wizardNavigationButton }) => (
            <Delegate.AddDelegate wizardNavigationButton={wizardNavigationButton} />
          ),
          showSkipButton: hrDelegates.length === 0,
          showNextButton: showAddDelegateFooterNext,
        },
      ],
    },
    {
      label: t('macroStepTitles.customize'),
      steps: [
        { label: 'Logo', component: <Aspect.SetLogo />, showSkipButton: true },
        { label: 'Color Palette', component: <Aspect.SetColor />, showSkipButton: true },
      ],
    },
    {
      label: t('macroStepTitles.companyData'),
      steps: [
        { label: 'Dati aziendali', component: <Company.SetData />, showSkipButton: true },
        {
          label: 'Dati aziendali',
          // eslint-disable-next-line react/no-unstable-nested-components
          component: ({ wizardNavigationButton }) => (
            <Company.VerifyData wizardNavigationButton={wizardNavigationButton} />
          ),
          nextButtonLabel: t('hr.verifyData.dialogEditImportedProfiles.cta.confirm'),
          skipButtonLabel: t('hr.verifyData.dialogEditImportedProfiles.cta.showData'),
          showSkipButton: false,
          showNextButton: false,
        },
        { label: 'Typ', component: <ConfigurationCompletedThankYouPage.Admin />, isTyp: true },
      ],
    },
  ];

  return <Wizard stepsConfig={wizardSteps} />;
};
